// extracted by mini-css-extract-plugin
export default {"page":"ResetPasswordPage_page__IjAJR","pageName":"ResetPasswordPage_pageName__v62J9"};